import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one document type
 * @primary Document type form
 * @persona danilo-tech
 */
export const Route = createFileRoute(
  "/app/admin/fsm-workflows/document-types/$id",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
